import AutoReplenishmentMain from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentMain/AutoReplenishmentMain';

export default AutoReplenishmentMain;
